export enum ContactRoleVariant {
  UNKNOWN = 'UNKNOWN',
  ACCOUNTING = 'ACCOUNTING',
  CEO = 'CEO',
  PRIMARY = 'PRIMARY',
  SALES = 'SALES',
  TECHNICAL = 'TECHNICAL',
}

export const CONTACT_ROLE_VARIANTS = Object.values(ContactRoleVariant);
